import project2 from "../assets/projects/rag.png";
import project3 from "../assets/projects/inventory.png";
import projectWeather from "../assets/projects/cloud-cost.png"; // Placeholder/Substitute fallback image if needed

export const PROJECTS = [
  {
    title: "AnalystAI (RAG Platform)",
    image: project2,
    description:
      "An AI-powered platform featuring a RAG pipeline (ChromaDB + HuggingFace embeddings + Llama 3.3) for instant dataset insights, automated cleaning, time-series forecasting (ARIMA), and automated PDF reports.",
    technologies: ["FastAPI", "Next.js", "ChromaDB", "Llama-3.3", "PostgreSQL", "Docker"],
    github: "https://github.com/VedantSinngh/RAG-Data-Analyser",
    deployed: "https://rag-data-analyser.vercel.app/",
  },
  {
    title: "Inventory Management System",
    image: project3,
    description:
      "Smart warehouse and inventory system featuring predictive forecasting, dynamic allocation heuristics, and responsive warehouse visualization.",
    technologies: ["Next.js", "Node.js", "Express", "MongoDB", "Tailwind CSS"],
    github: "https://github.com/VedantSinngh/inventory-management",
    deployed: "https://inventory-vs.vercel.app/",
  },
  {
    title: "Cloud Cost Analyser",
    image: projectWeather,
    description:
      "A clean visualization and analytics dashboard targeting optimization of multi-cloud infrastructure spends, forecasting anomalies, and outlining potential resource adjustments.",
    technologies: ["Next.js", "TypeScript", "Python", "Chart.js", "AWS APIs"],
    github: "https://github.com/VedantSinngh/cloud-cost-analyser",
    deployed: "#",
  },
];

export const RESEARCH = {
  label: "DRDO SAG — Quantum Computing Division",
  title: "Pulse-Level VQE for H₂ Ground State Energy Estimation",
  description:
    "Simulated pulse-level Variational Quantum Eigensolver for H₂ ground state energy in Qiskit Pulse. Shaped Gaussian and DRAG microwave pulses to drive qubit π-rotations, optimizing pulse parameters to minimize molecular energy estimates on noisy quantum hardware.",
  params: [
    { label: "Molecule", value: "H₂" },
    { label: "Method", value: "VQE" },
    { label: "Backend", value: "Qiskit Pulse" },
    { label: "Pulse Type", value: "Gaussian / DRAG" },
  ],
};

export const EXPERIENCES = [
  {
    date: "May 2025 — Present",
    role: "Research Intern",
    company: "SAG-DRDO",
    description:
      "Contributing to quantum machine learning research — pulse-level VQE simulation, QAOA optimization, and quantum circuit design using Qiskit and Python.",
    technologies: ["Python", "Qiskit", "Quantum ML"],
  },
  {
    date: "2024 — Present",
    role: "Admin-President",
    company: "Hack The Box SRMIST",
    description:
      "Led the development club, organized technical workshops and CTF competitions. Built and maintained web applications for club operations.",
    technologies: ["JavaScript", "React", "Node.js", "MongoDB"],
  },
  // {
  //   date: "2025",
  //   role: "1st Place",
  //   company: "Hackademia'25",
  //   description:
  //     "Won first place building a full-stack solution under 24-hour constraints with a team of four.",
  //   technologies: ["React", "Node.js", "ML"],
  // },
  // {
  //   date: "2024",
  //   role: "Top 50 Nationally",
  //   company: "Smart India Hackathon 2024",
  //   description:
  //     "Selected among top 50 teams nationally for an AI-driven solution addressing real-world governance challenges.",
  //   technologies: ["Python", "TensorFlow", "Next.js"],
  // },
];

export const CERTIFICATIONS = [
  {
    title: "AWS Certified Solutions Architect – Associate",
    issuer: "Amazon Web Services",
    issued: "Apr 2026",
    expires: "Apr 2029",
    credentialId: "354401a5-709c-4631-b56c-a0aa89ebdacf",
    link: "https://www.credly.com/badges/354401a5-709c-4631-b56c-a0aa89ebdacf",
    tag: "AWS",
  },
  {
    title: "AWS Certified Cloud Practitioner",
    issuer: "Amazon Web Services",
    issued: "Apr 2026",
    expires: "Apr 2029",
    credentialId: "c2740791-912d-416d-a9ff-54a95dc7a8d9",
    link: "https://www.credly.com/badges/c2740791-912d-416d-a9ff-54a95dc7a8d9",
    tag: "AWS",
  },
  {
    title: "AWS Certified AI Practitioner",
    issuer: "Amazon Web Services",
    issued: "Mar 2026",
    expires: "Mar 2029",
    credentialId: "59e7b562-c0a8-4a16-a75a-15c1badd7637",
    link: "https://www.credly.com/badges/59e7b562-c0a8-4a16-a75a-15c1badd7637",
    tag: "AWS",
  },
  {
    title: "Salesforce Certified Agentforce Specialist",
    issuer: "Salesforce",
    issued: "Dec 2025",
    expires: null,
    credentialId: "7322610",
    link: "https://www.salesforce.com/trailblazer/vedantsinngh",
    tag: "Salesforce",
  },
];

export const CONTACT = {
  email: "vedaantsinngh@gmail.com",
  linkedin: "https://www.linkedin.com/in/vedaantsinngh",
  github: "https://github.com/VedantSinngh",
  resume: "https://drive.google.com/file/d/1BVOrr6ibLe2cLDxkdleUJLEAPc9JZQBb/view?usp=sharing",
};
